/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Descriptor, { IDescriptorConstructor } from './descriptor';

export interface IMessageConstructor extends IDescriptorConstructor {
	new( ...args: unknown[] ): Message;

	readonly TYPE: string | number;

	readonly READABLE_TYPE_NAME: string;

	fromJSON( object: IMessage ): Message;
}

export interface IMessage {}

export default abstract class Message extends Descriptor {
	public declare [ 'constructor' ]: IMessageConstructor;

	public static readonly TYPE: string | number = '1000';

	public static readonly READABLE_TYPE_NAME: string;

	// required to allow subclasses to define custom constructor parameters
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor,no-unused-vars
	public constructor( ...args: unknown[] ) {
		super();
	}

	public abstract toJSON(): IMessage;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public static fromJSON( object: IMessage ): Message {
		throw new TypeError( 'Must be implemented in a child class!' );
	}
}
